export default "__VITE_ASSET__Btq1wN11__"